// Far plane of the desktop Blueprint: the wireframe skyline. Split out of blueprint.tsx.
import { motion, type MotionValue } from 'framer-motion';

export function BlueprintFar({ y, className }: { y: MotionValue<number>; className: string }) {
  return (
    <motion.svg
      className={className}
      viewBox="0 0 1600 900"
      preserveAspectRatio="xMaxYMin slice"
      style={{ y }}
    >
      <rect
        x="1480"
        y="-80"
        width="220"
        height="560"
        fill="none"
        stroke="var(--ink, #0a0a0b)"
        strokeWidth="1.25"
        opacity=".2"
      />
      <rect
        x="1480"
        y="200"
        width="220"
        height="140"
        fill="none"
        stroke="var(--ink, #0a0a0b)"
        strokeWidth="1.25"
        opacity=".2"
      />
      <rect
        x="1560"
        y="340"
        width="140"
        height="140"
        fill="none"
        stroke="var(--ink, #0a0a0b)"
        strokeWidth="1.25"
        opacity=".2"
      />
      <rect
        x="1440"
        y="-80"
        width="100"
        height="400"
        fill="none"
        stroke="var(--ink, #0a0a0b)"
        strokeWidth="1.25"
        opacity=".2"
      />
      <rect
        x="1440"
        y="120"
        width="100"
        height="200"
        fill="none"
        stroke="var(--ink, #0a0a0b)"
        strokeWidth="1.25"
        opacity=".2"
      />
      <rect
        x="1360"
        y="40"
        width="80"
        height="280"
        fill="none"
        stroke="var(--ink, #0a0a0b)"
        strokeWidth="1.25"
        opacity=".2"
      />
      <rect
        x="1360"
        y="200"
        width="80"
        height="120"
        fill="none"
        stroke="var(--ink, #0a0a0b)"
        strokeWidth="1.25"
        opacity=".2"
      />
      <rect
        x="1260"
        y="140"
        width="100"
        height="180"
        fill="none"
        stroke="var(--ink, #0a0a0b)"
        strokeWidth="1.25"
        opacity=".2"
      />
      <rect
        x="1180"
        y="220"
        width="80"
        height="120"
        fill="none"
        stroke="var(--ink, #0a0a0b)"
        strokeWidth="1.25"
        opacity=".2"
      />
      <rect
        x="1100"
        y="290"
        width="80"
        height="70"
        fill="none"
        stroke="var(--ink, #0a0a0b)"
        strokeWidth="1.25"
        opacity=".2"
      />
      <rect
        x="1100"
        y="360"
        width="160"
        height="60"
        fill="none"
        stroke="var(--ink, #0a0a0b)"
        strokeWidth="1.25"
        opacity=".2"
      />
    </motion.svg>
  );
}
